/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';

import { commonProp5 } from './commonProp5';
import { commonProp7 } from './commonProp7';
import { commonProp4 } from './commonProp4';

export const football_clothing : {[key: string]: Array<[string, string]>} = {
    p_sex: commonProp5,
    p_size: commonProp7,
    p_brand: [
        d("Adidas"),
        d("Nike"),
        d("Erima"),
        d("Uhlsport"),
        d("Puma"),
        d("Carbotex"),
        d("Fanatics"),
        d("Legea"),
        d("KEEPERsport"),
        d("New Balance"),
        d("Reebok"),
        ["HANDMADE", "Handmade"],
        ["OTHER_BRAND", "In\u00e1 zna\u010dka"],
    ],
    p_color: commonProp4,
};
